import { addToCart, removeFromCart, updateCartItem, clearCart } from '../cartSlice';

export const addItemToCart = (item) => {
  return (dispatch) => {
    dispatch(addToCart(item));
  };
};

export const removeItemFromCart = (item) => {
  return (dispatch) => {
    dispatch(removeFromCart(item));
    const currentCart = JSON.parse(localStorage.getItem('cart'));
    const updatedCart = currentCart.filter(
      (cartItem) => !(cartItem.product.id === item.productId && cartItem.size === item.size)
    );
    localStorage.setItem('cart', JSON.stringify(updatedCart));
  };
};

export const updateCartItemQuantity = (item) => {
  return (dispatch) => {
    dispatch(updateCartItem(item));
    const currentCart = JSON.parse(localStorage.getItem('cart'));
    const updatedCart = currentCart?.map((cartItem) => {
      if (cartItem.product.id === item.productId && cartItem.size === item.size) {
        return { ...cartItem, quantity: item.quantity };
      }
      return cartItem;
    });
    localStorage.setItem('cart', JSON.stringify(updatedCart));
  };
};

export const clearCartItems = () => {
  return (dispatch) => {
    dispatch(clearCart());
    localStorage.removeItem('cart');
  };
};